import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
    SettingOption,
} from '@appblocks/codegeneration/types';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export default class SMSNode extends BaseNode {
    constructor() {
        super();
        this.name = 'On SMS Received';
        this.id = 'node_sms_recv';
        this.icon = 'HiCommandLine';
        this.linkedFeature = 'cell';
        this.icon = 'FaEnvelope';


        const settings: Setting[] = [
        ];

        this.outputs = [
            {
                name: 'SMS Received',
                portId: 'sms_received',
                params: [
                    {
                        name: 'phone_number',
                        dataType: TibboDataType.STRING,
                    },
                    {
                        name: 'message',
                        dataType: TibboDataType.STRING,
                    },
                ],
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getDefines(): Array<Define> {
        return [
            {
                name: 'CELL__AT_USERMODE_ISENABLED',
                value: '1',
            },
        ];
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;
        const NUMBER = this.getSettingValue('NUMBER');
        const DATA = this.getSettingValue('DATA');

        blocks.push({
            location: 'GLOBAL_DECLARATIONS',
            blockType: BlockType.CODE,
            id: 'declare_cell_sms_send',
            template: `
declare sub cell_sms_send(byref phonenum as string, byref data as string)
`,
        });

        blocks.push({
            location: 'boot',
            blockType: BlockType.CODE,
            id: 'cell_sms_enabled',
            template: `
cell_sms_enabled = true
`,
        });

        blocks.push({
            location: 'boot_complete',
            blockType: BlockType.CODE,
            id: 'cell_ppp_enabled=false',
            template: `
'currently sms cannot be received if ppp is enabled
cell_ppp_enabled = false
`,
        });

        const links = project.getNodeLinks(this, 'sms_received');
        if (links.length > 0) {
            for (let i = 0; i < links.length; i++) {
                const link = links[i];
                const source: BaseNode = project.getFeature(link.getSettingValue('SOURCE_FEATURE')) as BaseNode;
                const sourceParams = source.getPort(link.getSettingValue('SOURCE_PORT'))?.params;

                blocks.push({
                    location: 'callback_sms_received',
                    blockType: BlockType.CODE,
                    id: link.getID(),
                    template: `'****${link.getSourceId()}****'`,
                });
            }
        }
        return blocks;
    }

    getDetails(): string {
        return `
`;
    }
}
